export const host = "https://chatwave-backend-jaibhalla03.onrender.com";

export const registerRoute = `${host}/api/auth/register`;

export const loginRoute = `${host}/api/auth/login`;

export const setAvatarRoute = `${host}/api/auth/setavatar`

export const allUserRoutes = `${host}/api/auth/allusers`;

export const sendMessageRoutes = `${host}/api/messages/addmsg`;

export const getAllMessagesRoutes = `${host}/api/messages/getmsg`;